import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { styles } from '../../style/style';

const NewsMessage = () => {

    return (
        <Box sx={{ pr: '2%' }}>
            <Typography id='newsTitle' variant='h3' sx={styles.h3SectionTitle}>
                <FormattedMessage id='newsmessage.appname' defaultMessage='News' />
            </Typography>
            <Typography id='newsName' variant='h4' sx={styles.h4InformationGroupHeader}>
                <FormattedMessage id='newsmessage.newsTitle' defaultMessage='Welcome to the Vehicle Order Status Website!' />
            </Typography>
            {/* <br/>
            <Typography id='newsDate' variant ='small' sx={styles.smallLegalText}>
                <FormattedMessage id='newsmessage.newsDate' defaultMessage='04/24/2023'/>
            </Typography>
            <br/> */}
            <br />
            <Typography id='newsBody' variant='p' sx={styles.pBodyText}>
                <FormattedMessage id='newsmessage.newsBody' defaultMessage='Use the navigation tabs at the top to generate reports, or, using the input field on the left, get a quick status of either five fleet Order Numbers, or one fleet VIN.\n\nPlease report any functionality issues to gmenvolvesolutionscenter@gm.com.\n\nThank you,\nThe GM Envolve Team' />
            </Typography>
        </Box>
    )
}
export default NewsMessage;